/* eslint-disable */
import { HTMLMotionProps, motion } from 'framer-motion'
import * as React from 'react'

export interface ModalTransitionProps
  extends Omit<HTMLMotionProps<'section'>, 'color' | 'transition'> {
  preset: 'slideInBottom' | 'slideInRight' | 'scale' | 'none'
}

const transitions = {
  slideInBottom: {
    custom: { offsetY: 16, reverse: true },
  },
  slideInRight: {
    custom: { offsetX: 16, reverse: true },
  },
  scale: {
    custom: { initialScale: 0.95, reverse: true },
  },
  none: {},
}

const Motion: any = motion.section

export const ModalTransition = React.forwardRef(
  (props: ModalTransitionProps, ref: React.Ref<any>) => {
    const { preset, ...rest } = props
    const motionProps = transitions[preset]
    return <Motion ref={ref} {...(motionProps as any)} {...rest} />
  },
)
